import Alpine from 'alpinejs';
import Swiper from 'swiper';
import { Keyboard, Navigation, Pagination } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';
// import styles bundle
import 'swiper/swiper.css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
document.addEventListener('alpine:init', () => {
    Alpine.data('initAbTestReviewSlider', () => {
        return {
            swiper: {},
            init() {
                const swiperParams: SwiperOptions = {
                    direction: 'horizontal',
                    modules: [Navigation, Keyboard, Pagination],
                    init: false,
                    loop: false,
                    slidesPerView: 1,
                    keyboard: {
                        enabled: true,
                    },
                    navigation: {
                        prevEl: this.$refs.buttonPrev,
                        nextEl: this.$refs.buttonNext,
                    },
                };

                const swiper = new Swiper(
                    this.$refs.swiperContainer,
                    swiperParams,
                );
                this.swiper = swiper;

                this.$nextTick(() => {
                    swiper.init();
                });
            },
        };
    });
});
